import { createContext, useState, useEffect, ReactNode, useContext, useCallback } from 'react';
import { useAPIContext } from './APIContext';

type UserContextType = {
    loading: boolean;
    totalPoints: number;
    fetchPoints: () => Promise<void>;
};

export const UserContext = createContext<UserContextType>({
    loading: false,
    totalPoints: 0,
    fetchPoints: async () => {},
});

export const UserProvider = ({ children }: { children: ReactNode }) => {
    const [totalPoints, setTotalPoints] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const { apiFetch } = useAPIContext();

    const fetchPoints = useCallback(async () => {
        setLoading(true);
        const points = await apiFetch<number>('Users/TotalPoints', 'GET');
        if (points) {
            setTotalPoints(points);
        }
        setLoading(false);
    }, [apiFetch]);

    useEffect(() => {
        fetchPoints();
    }, [fetchPoints]);

    return (
        <UserContext.Provider value={{ totalPoints, fetchPoints, loading }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserContext = () => useContext(UserContext);